<template>
  <div :class="bindInputClass">
    <input
      id="uid-input"
      ref="uid-input"
      v-model="uidValue"
      autocomplete="off"
      :type="inputType"
      :inputmode="inpuTmode"
      :placeholder="placeholderText"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      @keyup.enter="handleBlur"
      :class="bindUidClass"
      :style="bindInputStyle"
    />
    <!-- 错误校验的动画 start -->
    <div class="check-info">
      <img
        class="error"
        v-show="validator.isError"
        :src="require('@/assets/images/detail/uid_error.png')"
        alt="error"
        @click.stop="handleIcon"
        @mousedown="handleMousedown"
      />
      <img
        class="success"
        v-show="validator.isSuccess"
        :src="successIcon"
        alt="success"
      />
      <van-loading
        v-show="validator.isLoading"
        type="spinner"
        class="loading-icon"
      />
    </div>
  </div>
</template>
<script>
  import isEmpty from 'lodash/isEmpty'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { createUidParames, NEED_SKUID } from '@page_detail/utils/common'
  import {
    inputUidFail,
    inputUidSuccess,
    inputUidManual,
    autoInputUid,
  } from '@page_detail/firebase'
  import { storage } from '@/utils/storage'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { injectionCheckUid } from '@page_detail/utils/validators'
  import { hexToRgba } from '@/utils/hexToRgba'
  import { chineseReg } from '@/utils/regExp'

  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        inputmode: {
          tel: 'numeric',
          text: 'email',
        },
        serverLock: true, // 跟initLock一致、区别是需要等到serverList
        initLock: true, // 加锁；只执行一次[初始加载进行一次的UID校验、点击切换SKU等的时候不需要校验]
        serverId: '', // 联动DropDownSearch组件选中的serverId
        uidValue: '', //UID
        validator: {
          isInInput: false, // 是否在输入中
          isError: false, // 验证错误
          isSuccess: false, // 验证成功
          isLoading: false, // 验证中
        },
        errorCode: 200, // 报错code\显示特定的报错文案
      }
    },
    mounted() {
      this.initStateOfSurvival()
      this._getVpnQuerys()
    },
    computed: {
      ...mapState([
        'gameName',
        'selectedSkuInfo',
        'selectedPaymentInfo',
        'isDesktop',
        'isMobile',
        'region',
        'isMLBB',
      ]),
      ...mapState('detail', [
        'selectServerItem',
        'serverList',
        'selectChannelItem',
        'selectSkuItem',
        'isUidFocus',
        'isRenderCheckffuid',
        'checkffuid',
      ]),
      ...mapGetters([
        'selectedUidKey',
        'isVpnGames',
        'isEnterAnyGames',
        'selectedSuccessServiceKey',
        'isStateOfSurvival',
        'isRuStarMaker',
        'isGameOfKhans',
      ]),

      errrText() {
        const errMsg = this.$te(`${this.gameName}.uid_check_errorText`)
          ? this.$t(`${this.gameName}.uid_check_errorText`)
          : ''

        if (this.isRuStarMaker) {
          return this.$t(`publicDetails.uid_check_errorText`, {
            uid: 'SID',
          })
        }

        if (this.errorCode !== 200) {
          const isCode = this.$te(`apiErrorTips.${this.errorCode}`)
            ? this.$t(`${this.gameName}.uid_check_errorText`)
            : ''
          return isCode ? this.$t(`apiErrorTips.${this.errorCode}`) : errMsg
        }
        return errMsg
      },
      placeholderText() {
        if (this.isRuStarMaker) {
          return this.$t(`publicDetails.uid_placeholder`, {
            uid: 'SID',
          })
        }
        return this.$te(`${this.gameName}.uid_placeholder`)
          ? this.$t(`${this.gameName}.uid_placeholder`)
          : this.$t(`publicDetails.uid_placeholder`, {
              uid: 'UID',
            })
      },

      inputType() {
        if (this.isEnterAnyGames) {
          return 'text'
        }

        return 'tel'
      },

      inpuTmode() {
        return this.inputmode[this.inputType]
      },

      bindInputClass() {
        const defaultClass = ['input-uid']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        // 对于有serverList的数据、UID组件在【pc】不能100%展示
        // warn: FF的校验输入框 样式也一样
        if (this.serverList.length || this.isRenderCheckffuid) {
          device.push(`${defaultClass[0]}-server`)
        }
        return defaultClass.concat(device)
      },
      bindUidClass() {
        const classnames = ['input', this.gameName]
        let classTypes = []
        if (this.validator.isInInput) {
          classTypes.push('in-input')
        }
        if (this.validator.isError) {
          classTypes.push('error-input')
        }
        if (this.validator.isSuccess) {
          classTypes.push('success-input')
        }
        if (this.isDesktop) {
          classTypes.push('desktop-input')
        }
        return classnames.concat(classTypes)
      },

      bindInputStyle() {
        return {
          backgroundColor: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
          '--placeholderColor': hexToRgba(this.mFontColor.color),
        }
      },

      //warn: 统一处理依赖的校验数据结构
      selectRelyon() {
        return {
          citem: this.selectChannelItem,
          sitem: this.selectServerItem,
          alist: this.serverList,
        }
      },
      successIcon() {
        return require('@/assets/images/detail/common/success.png')
      },
    },
    watch: {
      isUidFocus(newVal) {
        if (newVal === -1) return
        this.$nextTick(() => {
          this.$refs['uid-input']['focus']()
        })
      },

      selectRelyon: {
        handler(newVal, oldVal) {
          const { citem = {}, sitem = {}, alist = [] } = newVal
          if (isEmpty(citem)) return
          // WARN： 切换的时候、需要校验UID的正确性
          if (sitem?.cpServerId !== oldVal?.sitem?.cpServerId) {
            this.serverId = sitem.cpServerId
            this.handleBlur()
          }
          if (alist.length && !isEmpty(sitem)) {
            this.serverId = sitem.cpServerId
            if (this.serverLock) {
              // const isCkser = this.chekServerUid()
              this.getCacheUid()
              this.handleBlur()
              this.serverLock = false
            }
          } else {
            if (this.initLock) {
              this.getCacheUid()
              this.handleBlur()
              this.initLock = false
            }
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      ...mapMutations([
        'detail/setNickName',
        'detail/setUserId',
        'detail/setCheckGokSkuids',
        'detail/setAccountId',
        'detail/setUidValidator',
        'detail/setIkCpServerId',
        'detail/setPublicSkuList',
      ]),

      initStateOfSurvival() {
        if (!this.isStateOfSurvival) return

        this.getCacheUid()
        this.handleBlur()
      },

      // 缓存成功的[server]key
      cachedSuccessfulServersKey(id = '') {
        if (this.serverList.length) {
          storage.set(this.selectedSuccessServiceKey, id) || null
        }
      },

      // 根据参数回显数据
      _getVpnQuerys() {
        const { uid = '' } = this.$route.query
        if (this.isVpnGames && uid) {
          this.uidValue = uid
          storage.set(this.selectedUidKey, uid)
        }
      },

      getCacheUid() {
        const cacheUid = storage.get(this.selectedUidKey) || null
        if (!cacheUid) return

        this.uidValue = cacheUid
        autoInputUid(this.gameName)
      },

      handleFocus() {
        inputUidManual(this.gameName)
      },

      handleCheck({
        isInInput = false,
        isError = false,
        isSuccess = false,
        isLoading = false,
      } = {}) {
        this.validator = {
          isInInput,
          isError,
          isSuccess,
          isLoading,
        }
        this['detail/setUidValidator'](this.validator)
      },

      handleInput() {
        const ischeck = this.inputChecking()
        if (!ischeck) return
        this['detail/setNickName']('')
      },

      inputChecking() {
        if (this.inputType === 'tel') {
          const successVal = storage.get(this.selectedUidKey)
          this.uidValue = this.uidValue.replace(/\D/g, '')

          return successVal !== this.uidValue
        }

        if (this.inputType === 'text') {
          this.uidValue = this.uidValue.replace(chineseReg, '')
          return true
        }
      },

      // [重点] 失焦校验UID
      async handleBlur() {
        let result = null,
          nickNameList = ''

        // 参考「https://github.com/youzan/vant/blob/2.x/src/field/index.js#L180 」
        if (this.$refs['uid-input']) {
          this.$refs['uid-input'].blur()
        }
        if (this.uidValue.trim() === '') {
          this.handleCheck()
          this['detail/setUserId']('')
          this['detail/setNickName']('')
          return
        }
        this.handleCheck({ isLoading: true })

        try {
          const params = createUidParames({
            gameName: this.gameName,
            uid: this.uidValue,
            selectSkuItem: this.selectSkuItem,
            selectServerItem: this.selectServerItem,
          })

          // tips： 有些CP比传SKUID\防止两次请求
          if (NEED_SKUID.includes(this.gameName)) {
            if (params.skuId) {
              result = await injectionCheckUid(params)
            }
          } else {
            result = await injectionCheckUid(params)
          }
        } catch (error) {
          window.console.warn('%c[handleBlur]方法报错', 'color:#0f0', error)
        }

        this.handleCheck({ isLoading: false })

        if (result && result.res) {
          this._hackGOKfilterSku(result)
          this._hackSSmergeSkuList(result)

          nickNameList = result.nick || result.roles || ''

          this['detail/setNickName'](nickNameList || '')
          this['detail/setUserId'](result.uid || '')
          this['detail/setAccountId'](result.accountId || '')
          this['detail/setIkCpServerId'](result.cpServerId || '')

          inputUidSuccess(this.gameName)

          this.handleCheck({ isSuccess: true })
          storage.set(this.selectedUidKey, this.uidValue)

          const serverId =
            'cpServerId' in this.selectServerItem
              ? this.selectServerItem.cpServerId
              : ''

          this.cachedSuccessfulServersKey(serverId)
        } else {
          const { errorCode = 'default', customTips } = result || {}
          this.errorCode = errorCode
          this['detail/setUidValidator']({ errorCode, customTips })
          this['detail/setNickName']('')
          this['detail/setUserId']('')
          this.handleCheck({ isError: true })
          inputUidFail(this.gameName, this.errorCode)

          if (this.isStateOfSurvival) {
            this['detail/setPublicSkuList']([])
          }

          if (this.isGameOfKhans) {
            this['detail/setCheckGokSkuids']([])
          }
        }
      },

      // warn 单独为【GOK】做过滤的限制
      _hackGOKfilterSku(data) {
        if (!this.isGameOfKhans) return

        const { skuIds = [] } = data
        if (!skuIds.length) return
        this['detail/setCheckGokSkuids'](skuIds)
      },

      handleIcon() {
        this.uidValue = ''
        this.$nextTick(() => {
          this.$refs['uid-input']['focus']()
          this.handleCheck()
        })
      },

      // https://segmentfault.com/q/1010000004950602
      handleMousedown(event) {
        event.preventDefault()
      },

      // SS的外部的SKU 通过校验UID获取
      _hackSSmergeSkuList(data) {
        if (!this.isStateOfSurvival) return

        const { cateProducts = {} } = data
        const keys = Object.keys(cateProducts) || []

        let skuDatas = []

        if (keys.length) {
          keys.forEach((item) => {
            if (Array.isArray(cateProducts[item])) {
              skuDatas = skuDatas.concat(cateProducts[item])
            }
          })

          this['detail/setPublicSkuList'](skuDatas)
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
